import { useEffect } from "react";

// Company login tenants (profile page, tenant and landlord): lets the
// Documents list grow so the Documents card ends where the side column
// ends, instead of scrolling inside a short box next to a long column.
// Sets --docs-side-body-height on the container; the CSS keeps the usual
// cap as the minimum (see .docs-match-side in skorList.css).
const useDocsBodyMatchSide = (container, sideSelector, enabled) => {
  useEffect(() => {
    if (!enabled || !container || typeof ResizeObserver === "undefined") {
      return undefined;
    }
    const update = () => {
      const side = container.querySelector(sideSelector);
      const body = container.querySelector(".mainWrapperForensicDocs");
      const card = body?.closest(".details-docs");
      if (!side || !body || !card) return;
      // Stacked columns (small screens): keep the usual cap.
      const sideRect = side.getBoundingClientRect();
      if (sideRect.left < card.getBoundingClientRect().right - 1) {
        container.style.removeProperty("--docs-side-body-height");
        return;
      }
      const cardStyle = window.getComputedStyle(card);
      const cardBottomSpace =
        parseFloat(cardStyle.paddingBottom) +
        parseFloat(cardStyle.borderBottomWidth);
      const height =
        sideRect.bottom - body.getBoundingClientRect().top - cardBottomSpace;
      container.style.setProperty(
        "--docs-side-body-height",
        `${Math.max(0, Math.round(height))}px`
      );
    };
    const observer = new ResizeObserver(update);
    observer.observe(container);
    const side = container.querySelector(sideSelector);
    if (side) observer.observe(side);
    update();
    return () => {
      observer.disconnect();
      container.style.removeProperty("--docs-side-body-height");
    };
  }, [container, sideSelector, enabled]);
};

export default useDocsBodyMatchSide;
